export const teeInfo = {
                "id": 9,
                "code": "LA20IQGAWJHZ",
                "name": "Printed T-Shirt for Men & Women - Short Sleeve Casual Tee",
                "description": "Material: 100% Cotton (180gsm fabric weight. Please note that material batch and supplier may vary to ensure stock stability, resulting in a normal weight tolerance of approx. ±10g.)\n\nFeatures & Benefits:\n\nPremium Material: Made from high-quality, soft cotton for all-day comfort and breathability.\n\nModern Design: Features a classic fit and vibrant heat transfer graphics, making it a must-have for casual, everyday summer wear.\n\nVersatile Styling: This unisex tee complements any body type and pairs effortlessly with jeans, chinos, or shorts.\n\nIdeal Gift: A perfect summer gift for family and friends, serving as an essential and stylish seasonal staple.\n\nIdeal For: Daily life, work, travel, and casual outings.\n\nCare Instructions: Machine washable. Do not soak for extended periods. Do not bleach. Wash at temperatures not exceeding 45°C.\n\nDesign & Sizing Note:\n\nFor Best Print Results: Please avoid designs with extremely thin lines, small dots, or using colors identical to the shirt's base color, as this may cause printing issues (e.g., ink dropout). Such design-related issues are not covered under our warranty.\n\nSizing: Please allow a slight measurement variance of up to 1 cm due to different measuring methods.\n\nImportant Reminder: Product images are for reference only. The actual item may have minor variations in color, print placement, or size due to different production batches. These slight deviations are considered normal and are not covered under warranty or return policy.",
                "keywords": null,
                "unitName": null,
                "categoryId": 3506,
                "basePrice": "16.99",
                "cost": "0.00",
                "barCode": null,
                "videoLink": null,
                "currency": "USD",
                "dimensions": null,
                "materials": null,
                "printAreas": null,
                "image": "https://mobuffer.oss-us-west-1.aliyuncs.com/8W/8WC7NX5F0.jpg",
                "sliderImages": "https://mobuffer.oss-us-west-1.aliyuncs.com/8W/8WC7OUKFY.jpg,https://mobuffer.oss-us-west-1.aliyuncs.com/8W/8WC8BZMUF.jpg,https://mobuffer.oss-us-west-1.aliyuncs.com/8W/8WC7VU406.jpg",
                "isActive": true,
                "isFeatured": false,
                "sortOrder": 0,
                "stock": 9999,
                "productType": 0,
                "tags": "",
                "metadata": {},
                "rating": "0.0",
                "reviews": 0,
                "createdAt": "2025-10-31T09:14:16.000Z",
                "updatedAt": "2026-06-18T09:08:48.000Z",
                "category": {
                    "id": 3506,
                    "name": "T-shirt",
                    "icon": "",
                    "href": "",
                    "parentId": 35,
                    "sortOrder": 1,
                    "isActive": true,
                    "isHot": false,
                    "createdAt": "2025-10-31T08:15:14.000Z",
                    "updatedAt": "2025-10-31T08:17:04.000Z"
                },
                "optionCombinations": [
                    {
                        "id": 2277,
                        "options": [
                            {
                                "groupId": 5,
                                "optionId": 8,
                                "groupName": "Size",
                                "optionName": "S"
                            }
                        ],
                        "price": "16.99",
                        "stock": 9999,
                        "sku": ""
                    },
                    {
                        "id": 2278,
                        "options": [
                            {
                                "groupId": 5,
                                "optionId": 11,
                                "groupName": "Size",
                                "optionName": "XL"
                            }
                        ],
                        "price": "16.99",
                        "stock": 9999,
                        "sku": ""
                    },
                    {
                        "id": 2279,
                        "options": [
                            {
                                "groupId": 5,
                                "optionId": 9,
                                "groupName": "Size",
                                "optionName": "M"
                            }
                        ],
                        "price": "16.99",
                        "stock": 9999,
                        "sku": ""
                    },
                    {
                        "id": 2280,
                        "options": [
                            {
                                "groupId": 5,
                                "optionId": 10,
                                "groupName": "Size",
                                "optionName": "L"
                            }
                        ],
                        "price": "16.99",
                        "stock": 9999,
                        "sku": ""
                    },
                    {
                        "id": 2281,
                        "options": [
                            {
                                "groupId": 5,
                                "optionId": 12,
                                "groupName": "Size",
                                "optionName": "XXL"
                            }
                        ],
                        "price": "16.99",
                        "stock": 9999,
                        "sku": ""
                    },
                    {
                        "id": 2282,
                        "options": [
                            {
                                "groupId": 5,
                                "optionId": 13,
                                "groupName": "Size",
                                "optionName": "3XL"
                            }
                        ],
                        "price": "16.99",
                        "stock": 9999,
                        "sku": ""
                    },
                    {
                        "id": 2283,
                        "options": [
                            {
                                "groupId": 5,
                                "optionId": 14,
                                "groupName": "Size",
                                "optionName": "4XL"
                            }
                        ],
                        "price": "16.99",
                        "stock": 9999,
                        "sku": ""
                    }
                ],
                "previews": [
                    {
                        "type": "model",
                        "url": ""
                    }
                ],
                "templates": [
                    {
                        "id": 1,
                        "name": "front",
                        "preview": "https://mobuffer.oss-us-west-1.aliyuncs.com/ef/ef3160d20381756cf9b3157bced4df1e.jpg",
                        "design": {
                            "view": "front",
                            "mask": "",
                            "backgrounds": [
                                {
                                    "option_value_id": "186",
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/4f/4f6730c620de5b6c4a7744aa675fb2b8.png",
                                    "optionName": "Red"
                                },
                                {
                                    "option_value_id": "175",
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/da/da53b283d18984a65038e055f9c4d95b.png",
                                    "optionName": "White"
                                },
                                {
                                    "option_value_id": "174",
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/76/768eac9ce161842196dd36fa9fe98776.png",
                                    "optionName": "Black"
                                },
                                {
                                    "option_value_id": 1,
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/4d/4da0814a4c721d81faba2234345efb78.png",
                                    "optionName": null
                                }
                            ],
                            "covers": [
                                {
                                    "option_value_id": "186",
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/02/028c8460fc97be336e5b867c682303db.png"
                                },
                                {
                                    "option_value_id": "175",
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/5c/5cc75d6673eec64a34ad9b83fc1b78a8.png"
                                },
                                {
                                    "option_value_id": "174",
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/e2/e2c936f0478c3c591989771dee0ab6b1.png"
                                },
                                {
                                    "option_value_id": 1,
                                    "src": "https://mobuffer.oss-us-west-1.aliyuncs.com/96/9687706c079e8e494198b5bd8dcc6fba.png"
                                }
                            ],
                            "faces": [
                                {
                                    "code": "VI20IQG9TGZJ",
                                    "demo": "demo.jpg",
                                    "width": 85,
                                    "height": 104.9,
                                    "position": {
                                        "x": 0,
                                        "y": 0,
                                        "z": -6
                                    },
                                    "scale": {
                                        "x": 0.5599999999999996,
                                        "y": 0.5599999999999996,
                                        "z": 0.5599999999999996
                                    },
                                    "rotation": {
                                        "x": -1.5707963267948966,
                                        "y": 0,
                                        "z": 0
                                    },
                                    "layers": [],
                                    "print_area": {
                                        "width": 0.3399999999999998,
                                        "height": 0.4195999999999997,
                                        "left": 0.33000000000000007,
                                        "top": 0.24734285714285728
                                    }
                                }
                            ]
                        }
                    }
                ]
            }